import './SocialMedia.css';
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";

const SocialMedia = () => {


    return (
        <div className='SocialMediaMainDiv'>

          <h2 className='NewsMainButton'>Social Media:</h2>

            <div className='MediaIconsMainDiv'>
               
	     <a href="https://www.youtube.com/@PolskaAkademiaTyczki" target="_blank" rel="noopener noreferrer">
           <FaYoutube className='MediaIcon'/>
         </a>
         <a href="https://www.instagram.com/polskaakademiatyczki/?__d=1utm_sourceig_embed" target="_blank" rel="noopener noreferrer">
           <FaInstagram className='MediaIcon'/>
         </a>
         <a href="https://www.facebook.com/profile.php?id=61586453996030" target="_blank" rel="noopener noreferrer">
           <FaFacebook className='MediaIcon'/>
         </a>

            </div>

        </div>
    )
}

export default SocialMedia;